<template>
  <div>
    <v-layout row wrap>
      <v-flex>
          <v-btn icon @click="openBox()" right absolute>
          <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">Habilitação
            <strong> Jurídica</strong>
          </h1>
      </v-flex>
    </v-layout>
<v-layout row wrap v-show="showBox">

<v-flex infoDados>
 <v-card>
  <div v-if="documentos">
    <div class="p-t-none">
      <div class="tituloBox">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Documentos</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="headers"
      :items="documentos"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="doc">
        <td >{{ doc.item.nomDocumento }}</td>        
        <td >{{ doc.item.datExpedicao | dataFormatada }}</td>
        <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="naoImprimir">
          <a v-if="doc.item.numDocumentoSEI" v-bind:href="doc.item.arquivoUpload" target="_blank">
            <v-icon color="blue">attach_file</v-icon>
          </a>
          <v-icon v-else color="grey">attach_file</v-icon>         
        </td> 
      </template>
    </v-data-table>
  </div>
  <br>

  <dirigentesTable :model="model" v-show="mostrarDirigente"/>
  <sociosTable :model="model"  v-show="mostrarSocio"/>
 </v-card>
 </v-flex>
 </v-layout>
  </div>
</template>
<script>
import sociosTable from "./components/extrato-socios-table";
import dirigentesTable from "./components/extrato-dirigentes-table";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "extrato-hablitacao-juridica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio:Object,
    enums:Object,
  },
    components: { /*Componentes utilizados*/
    dirigentesTable,
    sociosTable,
  },
  computed: {//Campos computados
    mostrarDirigente(){
      //mostrar listagem de dirigentes
      if(!this.model.fornecedoresHabilitacaoJuridica) return false;
      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "D"
      );
      if (lista.length) return true;
      else return false;
    },
      mostrarSocio(){
        //mostrar listagem de socios
      if(!this.model.fornecedoresHabilitacaoJuridica) return false;
      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "S"
      );
      if (lista.length) return true;
      else return false;
    }
  },
  created() /*Metodo de start do componente*/{
    this.documentos = this.model.documentosSolicitacao.filter(x=> x.numHabilitacao === '2')

    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
     
      this.headers.push({
        text: this.$t("label.anexo"),       
        sortable: false,        
      });    
    }
  },
  data() {//Declaracao de variaveis
    return {
      showBox:true,
      documentos: Object,
      loading: false,
      headers: [ /*Cabeçalho da data-table*/
        {
          text: this.$t("label.nome"),
          sortable: false,
        },
        {
          text: "Data",
          sortable: false,

        }
      ]
    };
  },
  watch: { //Propriedades assistidas
     "model": {
      handler(newValue) { /*Se houver um novo valor*/
        if (newValue) {
          this.documentos = this.model.documentosSolicitacao.filter(x=> x.numHabilitacao === '2')
        }
      }
    },
   },
  methods: {//Declaracao de todos os metodos

  openBox(){

    this.showBox=!this.showBox;
  },

  retornaEnumDescricao(_enum,valor){
    //retorna a descricao do enum
    if (!valor || !this.enums[_enum]) return ''
    let retorno = this.enums[_enum].find(x=>x.valor===valor);
    return retorno ? retorno.descricao : null;
  },


   baixarArquivo(arquivo) {
     //baixar o documento
     const numCgcFornecedor = this.$verificaPerfilCadastrador() ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "") : null;
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    },

  },
};
</script>

<style scoped> /*CSS especifico do componente*/

.infoDados .v-card{ padding: 15px;}

.infoDados .linhaInfo{
display: block;
padding: 5px 0;
}

.theme--light.v-table thead{
  background: none;
}

</style>


